import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, ExternalLink, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { calendlySrc, isCalendlyBooked, recordBooking } from "@/lib/recruiter";

// Inline Calendly page for the user's tier. The server verifies the booking and the allowance.
export const Booker = ({ url, title, onBooked }) => {
  const { user } = useAuth();
  const [state, setState] = useState("idle");
  useEffect(() => {
    const on = async (e) => {
      if (!isCalendlyBooked(e)) return;
      setState("saving");
      try { const d = await recordBooking(e.data.payload); setState("done"); toast.success(d?.message || "Booked. A confirmation email is on its way."); onBooked?.(d); }
      catch (err) { setState("idle"); toast.error(err.response?.status === 404 ? "Booked with Calendly. It will show here once our server confirms it." : err.response?.status === 403 ? (err.response?.data?.detail || "No sessions left this period.") : errMsg(err)); onBooked?.(null); }
    };
    window.addEventListener("message", on);
    return () => window.removeEventListener("message", on);
  }, [onBooked]);
  return (
    <div className="overflow-hidden rounded-2xl border border-[#27272A] bg-[#0b0a10]" data-testid="recruiter-booker">
      <div className="flex items-center justify-between gap-2 border-b border-[#27272A] px-4 py-2.5">
        <p className="text-sm font-semibold text-zinc-100">{title}</p>
        <a href={calendlySrc(url, user)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs text-[#c79bff] hover:underline" data-testid="recruiter-open-calendly">Open in new tab<ExternalLink className="h-3 w-3" /></a>
      </div>
      {state === "saving" && <p className="flex items-center gap-2 px-4 py-2 text-xs text-zinc-400"><Loader2 className="h-3.5 w-3.5 animate-spin" />Confirming your booking…</p>}
      {state === "done" && <p className="flex items-center gap-2 px-4 py-2 text-xs text-emerald-300" data-testid="recruiter-booked"><CheckCircle2 className="h-3.5 w-3.5" />Booked. Check your email for the invite and reminders.</p>}
      <iframe title="Book a recruiter" src={calendlySrc(url, user)} className="h-[700px] w-full" data-testid="recruiter-calendly-frame" />
      <p className="px-4 py-2 text-[11px] text-zinc-500">Only real open times are shown. Times depend on recruiter availability.</p>
    </div>
  );
};
